export const FETCH_RECENTLY_VIEWED = 'FETCH_RECENTLY_VIEWED';
